// One segment per credit of today's allowance: green for the ones left, grey for the ones used.
export default function CreditBar({ left, limit, dark = false, className = '' }) {
  if (limit == null) return null;
  const segments = Math.min(limit, 10);
  const filled = Math.round((left / limit) * segments);
  return (
    <div className={`flex gap-1 ${className}`} aria-hidden="true">
      {Array.from({ length: segments }, (_, i) => (
        <span key={i} className={`h-1.5 flex-1 rounded-full ${i >= segments - filled ? 'bg-primary' : dark ? 'bg-white/15' : 'bg-base-300'}`} />
      ))}
    </div>
  );
}
